import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import './App.css';
import Album from './components/Album/Album';


export default function App() {
  return (
    <Router>
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Switch>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/">
            <Album />
          </Route>
        </Switch>
    </Router>
  );
}


function About() {
  return (
    <>
      <h2>About</h2>
      <p>I want to help. More coming soon!</p>
    </>
  );
}

